export default "__VITE_ASSET__CUj8IC5s__"